/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminBookingRequest,
  AdminBookingSettings,
  AdminService,
  AdminServiceBooking,
  AdminServiceInstructor,
  AdminServiceListResponse,
  AdminV1OrganizationsPaymentsServiceBookingsListParams,
  AdminV1OrganizationsPaymentsServiceInstructorsListParams,
  AdminV1OrganizationsPaymentsServicesListParams,
  CreateBookingSettings,
  PaginatedAdminServiceBookingLogRowList,
  PaginatedAdminServiceInstructorList,
  ServiceReorder,
  ServiceReorderResponse,
  UpdateBookingSettings
} from '.././model';

import adminV1OrganizationsBookingSettingsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsBookingSettingsCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsBookingSettingsUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServiceBookingsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServiceBookingsCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServiceBookingsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServiceBookingsDestroyMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServiceBookingsRefundCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServiceInstructorsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServiceInstructorsCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServiceInstructorsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServiceInstructorsUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServiceInstructorsDestroyMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServicesListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServicesCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServicesRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServicesUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServicesDestroyMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsServicesReorderCreateMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsBookingSettingsRetrieve = (
    organizationId: number,
 options?: SecondParameter<typeof adminV1OrganizationsBookingSettingsRetrieveMutator<AdminBookingSettings>>,) => {
      return adminV1OrganizationsBookingSettingsRetrieveMutator<AdminBookingSettings>(
      {url: `/api/admin/v1/organizations/${organizationId}/booking_settings/`, method: 'GET'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsBookingSettingsCreate = (
    organizationId: number,
    createBookingSettings: NonReadonly<CreateBookingSettings>,
 options?: SecondParameter<typeof adminV1OrganizationsBookingSettingsCreateMutator<AdminBookingSettings>>,) => {
      return adminV1OrganizationsBookingSettingsCreateMutator<AdminBookingSettings>(
      {url: `/api/admin/v1/organizations/${organizationId}/booking_settings/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBookingSettings
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsBookingSettingsUpdate = (
    organizationId: number,
    updateBookingSettings: NonReadonly<UpdateBookingSettings>,
 options?: SecondParameter<typeof adminV1OrganizationsBookingSettingsUpdateMutator<AdminBookingSettings>>,) => {
      return adminV1OrganizationsBookingSettingsUpdateMutator<AdminBookingSettings>(
      {url: `/api/admin/v1/organizations/${organizationId}/booking_settings/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateBookingSettings
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsServiceBookingsList = (
    organizationId: number,
    params?: AdminV1OrganizationsPaymentsServiceBookingsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServiceBookingsListMutator<PaginatedAdminServiceBookingLogRowList | Blob>>,) => {
      return adminV1OrganizationsPaymentsServiceBookingsListMutator<PaginatedAdminServiceBookingLogRowList | Blob>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/service-bookings/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Create a new service booking.
 * @summary Create a new service booking.
 */
export const adminV1OrganizationsPaymentsServiceBookingsCreate = (
    organizationId: number,
    adminBookingRequest: AdminBookingRequest,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServiceBookingsCreateMutator<AdminServiceBooking>>,) => {
      return adminV1OrganizationsPaymentsServiceBookingsCreateMutator<AdminServiceBooking>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/service-bookings/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminBookingRequest
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsServiceBookingsRetrieve = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServiceBookingsRetrieveMutator<AdminServiceBooking>>,) => {
      return adminV1OrganizationsPaymentsServiceBookingsRetrieveMutator<AdminServiceBooking>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/service-bookings/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsServiceBookingsDestroy = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServiceBookingsDestroyMutator<void>>,) => {
      return adminV1OrganizationsPaymentsServiceBookingsDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/service-bookings/${id}/`, method: 'DELETE'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsServiceBookingsRefundCreate = (
    organizationId: number,
    id: string,
    adminServiceBooking: NonReadonly<AdminServiceBooking>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServiceBookingsRefundCreateMutator<AdminServiceBooking>>,) => {
      return adminV1OrganizationsPaymentsServiceBookingsRefundCreateMutator<AdminServiceBooking>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/service-bookings/${id}/refund`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminServiceBooking
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsServiceInstructorsList = (
    organizationId: number,
    params?: AdminV1OrganizationsPaymentsServiceInstructorsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServiceInstructorsListMutator<PaginatedAdminServiceInstructorList>>,) => {
      return adminV1OrganizationsPaymentsServiceInstructorsListMutator<PaginatedAdminServiceInstructorList>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/service-instructors/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsServiceInstructorsCreate = (
    organizationId: number,
    adminServiceInstructor: NonReadonly<AdminServiceInstructor>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServiceInstructorsCreateMutator<AdminServiceInstructor>>,) => {
      return adminV1OrganizationsPaymentsServiceInstructorsCreateMutator<AdminServiceInstructor>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/service-instructors/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminServiceInstructor
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsServiceInstructorsRetrieve = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServiceInstructorsRetrieveMutator<AdminServiceInstructor>>,) => {
      return adminV1OrganizationsPaymentsServiceInstructorsRetrieveMutator<AdminServiceInstructor>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/service-instructors/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsServiceInstructorsUpdate = (
    organizationId: number,
    id: string,
    adminServiceInstructor: NonReadonly<AdminServiceInstructor>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServiceInstructorsUpdateMutator<AdminServiceInstructor>>,) => {
      return adminV1OrganizationsPaymentsServiceInstructorsUpdateMutator<AdminServiceInstructor>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/service-instructors/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminServiceInstructor
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsServiceInstructorsDestroy = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServiceInstructorsDestroyMutator<void>>,) => {
      return adminV1OrganizationsPaymentsServiceInstructorsDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/service-instructors/${id}/`, method: 'DELETE'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsServicesList = (
    organizationId: number,
    params?: AdminV1OrganizationsPaymentsServicesListParams,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServicesListMutator<AdminServiceListResponse>>,) => {
      return adminV1OrganizationsPaymentsServicesListMutator<AdminServiceListResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/services/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsServicesCreate = (
    organizationId: number,
    adminService: NonReadonly<AdminService>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServicesCreateMutator<AdminService>>,) => {
      return adminV1OrganizationsPaymentsServicesCreateMutator<AdminService>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/services/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminService
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsServicesRetrieve = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServicesRetrieveMutator<AdminService>>,) => {
      return adminV1OrganizationsPaymentsServicesRetrieveMutator<AdminService>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/services/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsServicesUpdate = (
    organizationId: number,
    id: string,
    adminService: NonReadonly<AdminService>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServicesUpdateMutator<AdminService>>,) => {
      return adminV1OrganizationsPaymentsServicesUpdateMutator<AdminService>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/services/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminService
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsServicesDestroy = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServicesDestroyMutator<void>>,) => {
      return adminV1OrganizationsPaymentsServicesDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/services/${id}/`, method: 'DELETE'
    },
      options);
    }
  /**
 * Bulk update sort_order for services based on the order of IDs provided.
 * @summary Bulk update sort_order for services based on the order of IDs provided.
 */
export const adminV1OrganizationsPaymentsServicesReorderCreate = (
    organizationId: number,
    serviceReorder: ServiceReorder,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServicesReorderCreateMutator<ServiceReorderResponse>>,) => {
      return adminV1OrganizationsPaymentsServicesReorderCreateMutator<ServiceReorderResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/services/reorder/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: serviceReorder
    },
      options);
    }
  export type AdminV1OrganizationsBookingSettingsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBookingSettingsRetrieve>>>
export type AdminV1OrganizationsBookingSettingsCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBookingSettingsCreate>>>
export type AdminV1OrganizationsBookingSettingsUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBookingSettingsUpdate>>>
export type AdminV1OrganizationsPaymentsServiceBookingsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServiceBookingsList>>>
export type AdminV1OrganizationsPaymentsServiceBookingsCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServiceBookingsCreate>>>
export type AdminV1OrganizationsPaymentsServiceBookingsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServiceBookingsRetrieve>>>
export type AdminV1OrganizationsPaymentsServiceBookingsDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServiceBookingsDestroy>>>
export type AdminV1OrganizationsPaymentsServiceBookingsRefundCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServiceBookingsRefundCreate>>>
export type AdminV1OrganizationsPaymentsServiceInstructorsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServiceInstructorsList>>>
export type AdminV1OrganizationsPaymentsServiceInstructorsCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServiceInstructorsCreate>>>
export type AdminV1OrganizationsPaymentsServiceInstructorsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServiceInstructorsRetrieve>>>
export type AdminV1OrganizationsPaymentsServiceInstructorsUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServiceInstructorsUpdate>>>
export type AdminV1OrganizationsPaymentsServiceInstructorsDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServiceInstructorsDestroy>>>
export type AdminV1OrganizationsPaymentsServicesListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServicesList>>>
export type AdminV1OrganizationsPaymentsServicesCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServicesCreate>>>
export type AdminV1OrganizationsPaymentsServicesRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServicesRetrieve>>>
export type AdminV1OrganizationsPaymentsServicesUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServicesUpdate>>>
export type AdminV1OrganizationsPaymentsServicesDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServicesDestroy>>>
export type AdminV1OrganizationsPaymentsServicesReorderCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServicesReorderCreate>>>
